(function($){
    $(document).ready(function() {
        /*$('.pt-hover-box .pt-hover-box-title').each(function() {
            $(this).css('bottom', -$(this).outerHeight());
        });

        $('.pt-hover-box').hover(function() {
            $(this).find('.pt-hover-box-title').stop().animate({ 'bottom': 0 }, 600);
        }, function() {
            $(this).find('.pt-hover-box-title').stop().animate({ 'bottom': -$(this).outerHeight() }, 600);
        });*/

        $('.vertical-tabs-wrapper .vertical-tabs-item').each(function() {
            var title = '<div class="vertical-tabs-title" data-target="#' + $(this).attr('id') + '">' + $(this).attr('data-title') + '</div>';
            $(this).parent().siblings('.vertical-tabs-titles').append(title);
        });

        $('.vertical-tabs-wrapper .vertical-tabs-item:first-child').show();

        $('.vertical-tabs-title:first-child').addClass('active-tab');

        $('.vertical-tabs-title').on('click', function() {
            $('.vertical-tabs-title').removeClass('active-tab');

            var target = $(this).attr('data-target');
            $(this).parent().siblings('.vertical-tabs-items').find('.vertical-tabs-item').hide();
            
            $(this).addClass('active-tab');

            $(target).show();
        });
    });
})(jQuery);